<div class="tw-flex gap-1">
  @for (template of actionTemplates; track template) {
    @if (tableItem?.hideAction !== template?.name) {
      <cohrex-button
        [small]="true"
        (click)="handleActionClicked($event, template)"
        className="{{ template.buttonStyle }} tw-shadow-lg"
      >
        <span class="material-icons tw-text-base">{{ template.icon }}</span>
        @if (template.iconLabel) {
          <div class="tw-ml-1 tw-text-sm tw-font-bold">
            {{ template.iconLabel | translate }}
          </div>
        }
      </cohrex-button>
    }
  }
</div>
